module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO30uYntmaWxsOiNmZmY7b3BhY2l0eTowLjc7fTwvc3R5bGU+PC9kZWZzPjxyZWN0IGNsYXNzPSJhIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDIpIj48cGF0aCBjbGFzcz0iYiIgZD0iTTEyLDJBMTAsMTAsMCwxLDAsMjIsMTIsMTAuMDI5LDEwLjAyOSwwLDAsMCwxMiwyWm00LjIsMTQuMkwxMSwxM1Y3aDEuNXY1LjJMMTcsMTQuOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yIC0yKSIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_watch.svg
// module id = GXk1
// module chunks = 97